"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInputStepper = exports.formatTimeValue = exports.hoursMinsSecsToNumber = void 0;
const React = __importStar(require("react"));
const InputStepper_1 = require("./InputStepper");
const hoursMinsSecsToNumber = (time) => Number(time.substring(0, 4).replace(':3', '.5').replace(':', '.'));
exports.hoursMinsSecsToNumber = hoursMinsSecsToNumber;
const formatTimeValue = (value) => value % 1 > 0 ? `${Math.floor(value)}:30` : `${Math.floor(value)}:00`;
exports.formatTimeValue = formatTimeValue;
const TimeInputStepper = ({ id, value, onClick }) => {
    return (React.createElement(InputStepper_1.InputStepper, { id: id, onClick: (v) => {
            onClick((0, exports.formatTimeValue)(v));
        }, value: (0, exports.hoursMinsSecsToNumber)(value), minValue: 0, maxValue: 23, step: 1, valueFormatter: (v) => (0, exports.formatTimeValue)(v) }));
};
exports.TimeInputStepper = TimeInputStepper;
//# sourceMappingURL=TimeInputStepper.js.map